'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2017/6/15.
                    */
/**
 * Created by lyj on 2016/10/19.
 */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DesignerDetailComponent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(DesignerDetailComponent, _Component);

  function DesignerDetailComponent() {
    (0, _classCallCheck3.default)(this, DesignerDetailComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(DesignerDetailComponent).call(this));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(DesignerDetailComponent, [{
    key: 'render',
    value: function render() {
      var styles = require('./DesignerDetailComponent.scss');
      var _props = this.props;
      var data = _props.data;
      var backgroundImg = _props.backgroundImg;
      var page = _props.page;

      var nameStyle = {};
      if (page === 'designerProductList') {
        nameStyle = { borderBottom: '2px solid #fff' };
      }
      if (page === 'workstationshopinfo') {
        nameStyle = { width: '375px', fontSize: '22px' };
      }
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'div',
          { className: styles.imgAndDescribeNew },
          _react2.default.createElement('img', { className: styles.backgroundImg,
            src: backgroundImg, alt: '' }),
          _react2.default.createElement(
            'div',
            { className: styles.textBox },
            page === 'designerProductList' ? _react2.default.createElement('div', { className: styles.backG }) : '',
            _react2.default.createElement(
              'p',
              { className: styles.shopName, style: nameStyle },
              data.name
            ),
            data.honor ? _react2.default.createElement(
              'p',
              { className: styles.text },
              data.honor
            ) : '',
            data.mobile ? _react2.default.createElement(
              'p',
              { className: styles.text2, style: { marginTop: '30px' } },
              _react2.default.createElement(
                'span',
                { className: styles.span1 },
                '电话：'
              ),
              _react2.default.createElement(
                'span',
                {
                  className: styles.span2 },
                data.mobile
              )
            ) : '',
            data.address ? _react2.default.createElement(
              'p',
              { className: styles.text2 },
              _react2.default.createElement(
                'span',
                { className: styles.span1 },
                '地址：'
              ),
              _react2.default.createElement(
                'span',
                {
                  className: styles.span2 },
                data.address
              )
            ) : ''
          )
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return DesignerDetailComponent;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object.isRequired,
  backgroundImg: _react.PropTypes.string.isRequired,
  page: _react.PropTypes.string
}, _temp);
exports.default = DesignerDetailComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/DesignerDetailComponent/DesignerDetailComponent.js
 ** module id = 1324
 ** module chunks = 0
 **/